import { Component } from '@angular/core';

@Component({
    selector: 'msi-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'location-service-admin-ui';
}
